import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PhysicalResourcesEditor.html?raw';
import lang from 'dojo/_base/lang';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import Tooltip from '../../../moreCore/UI/Floating/Tooltip';
import MainCatalogSelectV2 from '../MainCatalogSelectV2';

class PhysicalResourcesEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private warningSection: HTMLElement;
    private toastId: string = null;

    private selectContainer: HTMLElement;
    private resourceMainGroupSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;

    private input_Quantity: MdsLax<InstanceType<typeof NumberInput>>;
    private warningLevel1: HTMLElement;
    private warningLevel2: HTMLElement;
    private dt_Input_time_forerun: MdsLax<InstanceType<typeof NumberInput>>;
    private dt_Input_time_trailer: MdsLax<InstanceType<typeof NumberInput>>;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.UiModder.domClass.toggle(this.warningSection, "w3-disabled", !this.getAttributeValue("quantity"));

        var group = this.getAttributeValue("ref_resource_main_group.ID");

        this.resourceMainGroupSelect.setCatalog(MainCatalogs_Classes.ResourceMainGroup, this.translations["General_Label_PhysicalResourcesGroup"], group);
    }

    protected _onChanged(attribute: string, value: any) {
        this.setAttributeValue(attribute, value);

        switch (attribute) {
            case "quantity":
                this.adjustQuantityAndWarnings();
                break;
            case "warning_quantity_level1":
            case "warning_percentage_level1":
            case "warning_quantity_level2":
            case "warning_percentage_level2":
                this.adjustCorrespondingValue(attribute);
                break;
        }
    }

    private adjustCorrespondingValue(attribute: string) {
        let quantity = this.getAttributeValue("quantity");
        let attributeValue = this.getAttributeValue(attribute);
        let value = 0;

        switch (attribute) {
            case "warning_quantity_level1":
                value = attributeValue / quantity * 100;
                this.setAttributeValue("warning_percentage_level1", value);
                break;
            case "warning_percentage_level1":
                value = quantity * attributeValue / 100;
                this.setAttributeValue("warning_quantity_level1", value);
                break;
            case "warning_quantity_level2":
                value = attributeValue / quantity * 100;
                this.setAttributeValue("warning_percentage_level2", value);
                break;
            case "warning_percentage_level2":
                value = quantity * attributeValue / 100;
                this.setAttributeValue("warning_quantity_level2", value);
                break;
        }
    }

    private adjustQuantityAndWarnings() {

        let quantityIsYeroNull = !this.getAttributeValue("quantity");
        let valuesAreZeroNull: boolean = !this.getAttributeValue("warning_quantity_level1") &&
            !this.getAttributeValue("warning_quantity_level2") &&
            !this.getAttributeValue("warning_percentage_level1") &&
            !this.getAttributeValue("warning_percentage_level2");


        this.UiModder.domClass.add(this.warningSection, "w3-disabled");

        if (!quantityIsYeroNull && !valuesAreZeroNull) {

            let dlg = new GenericDialog();
            dlg.show(
                this.translate("PhysicalResource_Toast_Title_WarningTreshold"),
                null, null,
                "fas fa-question",
                null, null,
                { size: "smaller" });
            dlg.addButton(
                "quantity",
                this.translate("PhysicalResource_Toast_Option_Quantity"),
                lang.hitch(this, this.adjustWarningValues, "quantity"),
                null, null, null, true);
            dlg.addButton(
                "percent",
                this.translate("PhysicalResource_Toast_Option_Percent"),
                lang.hitch(this, this.adjustWarningValues, "percent"),
                null, null, null, true);
            dlg._setOkBtnAttr(false);
            dlg._setTopCloseBtnAttr(false);
            return;
        }

        this.UiModder.domClass.toggle(this.warningSection, "w3-disabled", quantityIsYeroNull);
    }

    adjustWarningValues(value: "quantity" | "percent") {
        console.debug("VALUE", value)
        let quantity = this.getAttributeValue("quantity");
        let quantity_level1 = this.getAttributeValue("warning_quantity_level1");
        let percentage_level1 = this.getAttributeValue("warning_percentage_level1");
        let quantity_level2 = this.getAttributeValue("warning_quantity_level2");
        let percentage_level2 = this.getAttributeValue("warning_percentage_level2");

        switch (value) {
            case "quantity":
                percentage_level1 = quantity_level1 / quantity * 100;
                percentage_level2 = quantity_level2 / quantity * 100;
                this.setAttributeValue("warning_percentage_level1", percentage_level1);
                this.setAttributeValue("warning_percentage_level2", percentage_level2);
                break;
            case "percent":
                quantity_level1 = quantity * percentage_level1 / 100;
                quantity_level2 = quantity * percentage_level2 / 100;
                this.setAttributeValue("warning_quantity_level1", quantity_level1);
                this.setAttributeValue("warning_quantity_level2", quantity_level2);
                break;
        }
        this.UiModder.domClass.remove(this.warningSection, "w3-disabled");
    }

    private _defineTooltips() {
        let tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("PhysicalResource_Tooltip_Quantity"),
            targetnode: this.input_Quantity.domNode,
            icon: "fas fa-info-circle"
        })
        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("PhysicalResource_Tooltip_WarningLevel1"),
            targetnode: this.warningLevel1,
            icon: "fas fa-info-circle"
        })
        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("PhysicalResource_Tooltip_WarningLevel2"),
            targetnode: this.warningLevel2,
            icon: "fas fa-info-circle"
        })
        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("PhysicalResource_Tooltip_DurationForerun"),
            targetnode: this.dt_Input_time_forerun.domNode,
            icon: "fas fa-info-circle"
        })
        tooltip = new Tooltip();
        tooltip.setup({
            content: this.translate("PhysicalResource_Tooltip_DurationTrailer"),
            targetnode: this.dt_Input_time_trailer.domNode,
            icon: "fas fa-info-circle"
        })
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.PhysicalResources;
    }

    private _onChangeSelect(): void {
        var value = this.resourceMainGroupSelect.getValue();
        this.setAttributeValue("ref_resource_main_group", value, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._defineTooltips();

        this.resourceMainGroupSelect = new MainCatalogSelectV2();

        this.resourceMainGroupSelect.placeAt(this.selectContainer);
        this.resourceMainGroupSelect.on("change", lang.hitch(this, this._onChangeSelect));

        this.resourceMainGroupSelect.setCatalog(MainCatalogs_Classes.ResourceMainGroup, this.translations["General_Label_PhysicalResourcesGroup"]);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PhysicalResourcesEditor);